import { FC } from "react";
import { Flex, Stack, Text, LegacyText } from "flicket-ui";
import { Calendar, MapPin } from "@phosphor-icons/react";

interface PageHeaderProps {
  title: string;
  location?: string;
  date?: string;
}

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  location,
  date,
  children,
}) => {
  return (
    <Flex flexDirection="row" justifyContent="space-between" space={2} py={2}>
      <Stack direction="vertical" alignItems="flex-start" gap={1}>
        <Text variant="header.L" color="N800">
          {title}
        </Text>
        {location && (
          <Stack direction="horizontal" alignItems="center" gap={1}>
            <MapPin />
            <LegacyText>{location}</LegacyText>
          </Stack>
        )}
        {date && (
          <Stack direction="horizontal" alignItems="center" gap={1}>
            <Calendar />
            <LegacyText>{date}</LegacyText>
          </Stack>
        )}
      </Stack>
      <Stack
        direction={{
          base: "vertical",
          sm: "horizontal",
          md: "vertical",
        }}
        justifyContent="center"
        alignItems="stretch"
        minW={{ base: "100%", md: "390px" }}
        px={2}
        py={2}
        boxShadow="card"
        borderRadius={{ _: "none", md: "md" }}
        position={{ base: "fixed", md: "static" }}
        bottom={{ base: 0, md: "auto" }}
        left={{ base: 0, md: "auto" }}
        right={{ base: 0, md: "auto" }}
        bg="white"
        gap={2}
        zIndex={10}
      >
        {children}
      </Stack>
    </Flex>
  );
};
